import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Step,
  StepDescription,
  StepIcon,
  StepIndicator,
  Stepper,
  StepSeparator,
  StepStatus,
  StepTitle,
  Text,
  useSteps,
} from "@chakra-ui/react";
import React from "react";
import { totalApplicationSubmittedSteps } from "../../constants";

const ApplicationSubmittedModal = ({ currentActiveStep, onClose, isOpen }) => {
  const { activeStep, setActiveStep } = useSteps({
    index: currentActiveStep,
    count: totalApplicationSubmittedSteps.length,
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent borderRadius={"20px"} py={3} px={1}>
        <ModalHeader>
          Application Status
          <Text mt={1} color={"gray.600"} fontSize={"md"} fontWeight={"medium"}>
            Track and manage your submissions here.
          </Text>
        </ModalHeader>
        <ModalBody>
          <Stepper
            index={activeStep}
            orientation="vertical"
            gap="0"
            size="sm"
            colorScheme="teal"
            width="90%"
          >
            {totalApplicationSubmittedSteps.map((step, index) => (
              <Step key={index + " " + step.title}>
                <StepIndicator>
                  <StepStatus
                    complete={index < activeStep ? <StepIcon /> : undefined}
                  />
                </StepIndicator>

                <Box
                  flexShrink="2"
                  display={{ base: "none", md: "block" }}
                  mb="7"
                >
                  <StepTitle>{step.title}</StepTitle>
                  <StepDescription>{step.description}</StepDescription>
                </Box>

                {index !== totalApplicationSubmittedSteps.length - 1 && (
                  <StepSeparator height="70px" />
                )}
              </Step>
            ))}
          </Stepper>
        </ModalBody>
        <ModalFooter marginX={"auto"} mt="0" pt="0">
          <Button
            variant={"outline"}
            mr={3}
            onClick={onClose}
            width={"36"}
            borderRadius={"lg"}
          >
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ApplicationSubmittedModal;
